export enum SourceTypes {
  TF = 'TF',
  DLD = 'DLD',
  UserCreated = 'UserCreated',
}
